export default __webpack_public_path__ + "static/media/invoices_icon.b1aa0844.svg";